import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/terms-and-conditions');

const TermsAndConditionsFxs = {
    loadRelevantFx: domain.effect(api.termsAndConditions.loadRelevant),
    isRelevantSignedFx: domain.effect(api.termsAndConditions.isRelevantSigned),
    signRelevantFx: domain.effect(api.termsAndConditions.signRelevant),
};

export default TermsAndConditionsFxs;
